var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 271.2C37.3 297.2 71.6 326.6 138 326.6C204.4 326.6 238.7 297.2 269 271.2C297.6 246.6 322.4 225.4 374 225.4C425.6 225.4 450.3 246.6 479 271.2C487.4 278.4 500 277.4 507.2 269C514.4 260.6 513.4 248 505 240.8C474.7 214.8 440.4 185.4 374 185.4C307.6 185.4 273.3 214.8 243 240.8C214.4 265.4 189.6 286.6 138 286.6C86.4 286.6 61.7 265.4 33 240.8C24.6 233.6 12 234.6 4.79999 243C-2.40001 251.4 -1.40001 264 6.99999 271.2Z",
    fill: "#19A0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 161.8C37.3 187.8 71.6 217.2 138 217.2C204.4 217.2 238.7 187.8 269 161.8C297.6 137.2 322.4 116 374 116C425.6 116 450.3 137.2 479 161.8C487.4 169 500 168 507.2 159.6C514.4 151.2 513.4 138.6 505 131.4C474.7 105.4 440.4 76 374 76C307.6 76 273.3 105.4 243 131.4C214.4 156 189.6 177.2 138 177.2C86.4 177.2 61.7 156 33 131.4C24.6 124.2 12 125.2 4.79999 133.6C-2.40001 142 -1.40001 154.6 6.99999 161.8Z",
    fill: "#19A0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 350.2C474.7 324.2 440.4 294.8 374 294.8C307.6 294.8 273.3 324.2 243 350.2C214.4 374.8 189.6 396 138 396C86.4 396 61.7 374.8 33 350.2C24.6 343 12 344 4.79999 352.4C-2.40001 360.8 -1.40001 373.4 6.99999 380.6C37.3 406.6 71.6 436 138 436C204.4 436 238.7 406.6 269 380.6C297.6 356 322.4 334.8 374 334.8C425.6 334.8 450.3 356 479 380.6C487.4 387.8 500 386.8 507.2 378.4C514.4 370 513.4 357.4 505 350.2Z",
    fill: "#19A0F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwell);
export default __webpack_public_path__ + "static/media/swell.b7b5c32dcaa5f3ff8766245b35fbe7d2.svg";
export { ForwardRef as ReactComponent };